import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";
import { PlanCards, IntervalToggle } from "@/pages/site/Pricing";

export const PlanPicker = ({ business, onSaved }) => {
  const [plans, setPlans] = useState([]);
  const [interval, setInterval] = useState("month");
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    api.get("/plans").then((r) => setPlans(r.data)).catch(() => {});
  }, []);
  const choose = async (plan_id) => {
    setBusy(plan_id);
    try {
      const { data } = await api.post("/business/subscription", { plan_id, billing_cycle: interval === "year" ? "annual" : "monthly" });
      toast.success("Plan selected — your 14-day free trial is active");
      await onSaved(data);
    } catch (err) { toast.error(formatError(err)); } finally { setBusy(null); }
  };
  return (
    <div className="space-y-5" data-testid="plan-picker">
      <IntervalToggle value={interval} onChange={setInterval} />
      <PlanCards plans={plans} interval={interval} current={business.subscription?.plan_id}
        action={(p, cur) => (cur ? <p className="text-center text-sm font-semibold text-[#00A85C]" data-testid={`plan-current-${p.plan_id}`}>Current plan</p>
          : <Button onClick={() => choose(p.plan_id)} disabled={!!busy} className="w-full rounded-full bg-[#0B2A5B]" data-testid={`plan-select-${p.plan_id}`}>{busy === p.plan_id ? "Selecting…" : "Start 14-day free trial"}</Button>)} />
      <p className="text-xs text-slate-500">No card needed for the trial. You'll add payment details from the Subscription page.</p>
    </div>
  );
};
